module.exports = __webpack_public_path__ + "img/kamisado.67f6f637.jpg";